import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Paper,
  Box,
  TextField,
  TableContainer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const G9PortsBingo = () => {
  const [data, setData] = useState([]);
  const [statusNumbersViber, setstatusNumbersViber] = useState([]);
  const [statusNumbersGrab, setstatusNumbersGrab] = useState([]);
  const [statusNumbersFoodpanda, setstatusNumbersFoodpanda] = useState([]);
  const [statusNumbersGmail, setstatusNumbersGmail] = useState([]);
  const [statusNumbersGigalink, setstatusNumbersGigalink] = useState([]);
  const [statusNumbersGcash, setstatusNumbersGcash] = useState([]);
  const [statusNumbersPlayzone, setstatusNumbersPlayzone] = useState([]);
  const [statusNumbersWhatsapp, setstatusNumbersWhatsapp] = useState([]);
  const [statusNumbersMoveit, setstatusNumbersMoveit] = useState([]);
  const [statusNumbersHotel101, setstatusNumbersHotel101] = useState([]);
  const [servicesData, setServicesData] = useState({});
  const [senderContent, setSenderContent] = useState({});
  const [selectedService, setSelectedService] = useState('');
  const [monitorData, setMonitorData] = useState([]);
  const [senders, setSenders] = useState('');
  const [contents, setContents] = useState('');
  const [newSenders, setNewSenders] = useState('');
  const [newContents, setNewContents] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [actionToConfirm, setActionToConfirm] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success', 'error', 'warning', 'info'
  const [noOtpNumbersViber, setNoOtpNumbersViber] = useState({});
  const [noOtpNumbersGrab, setNoOtpNumbersGrab] = useState({});
  const [noOtpNumbersFoodpanda, setNoOtpNumbersFoodpanda] = useState({});
  const [noOtpNumbersGmail, setNoOtpNumbersGmail] = useState({});
  const [noOtpNumbersGigalink, setNoOtpNumbersGigalink] = useState({});
  const [noOtpNumbersGcash, setNoOtpNumbersGcash] = useState({});
  const [noOtpNumbersPlayzone, setNoOtpNumbersPlayzone] = useState({});
  const [noOtpNumbersWhatsapp, setNoOtpNumbersWhatsapp] = useState({});
  const [noOtpNumbersMoveit, setNoOtpNumbersMoveit] = useState({});
  const [noOtpNumbersHotel101, setNoOtpNumbersHotel101] = useState({});


  useEffect(() => {
    const fetchSenderContent = async () => {
      try {
        // 32 labels in order
        const labelKeys = [
          "one", "two", "three", "four", "five", "six", "seven", "eight",
          "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
          "seventeen", "eighteen", "nineteen", "twenty", "twentyone", "twentytwo", "twentythree", "twentyfour",
          "twentyfive", "twentysix", "twentyseven", "twentyeight", "twentynine", "thirty", "thirtyone", "thirtytwo"
        ];
  
        // Build the full array of endpoints
        const baseUrl = "https://frek.cc/proxy/38.54.86.24:5075/get-sender-content-";
        const senderEndpoints = labelKeys.map(label => `${baseUrl}${label}`);
  
        // Fetch all sender contents in parallel
        const responses = await Promise.all(senderEndpoints.map(url => fetch(url)));
        const data = await Promise.all(responses.map(res => res.json()));
  
        // Build an object like { one: [...], two: [...], ..., thirtytwo: [...] }
        const senderData = {};
        labelKeys.forEach((label, i) => {
          senderData[label] = data[i]?.senders || [];
        });
  
        // Store this object in state
        setSenderContent(senderData);
  
      } catch (error) {
        console.error("Error fetching sender content:", error);
      }
    };
  
    fetchSenderContent();
  }, []);
  


  // 1) Create a dark theme
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#121212',
        paper: '#1e1e1e',
      },
      text: {
        primary: '#ffffff',
      },
      primary: {
        main: '#90caf9',
      },
      error: {
        main: '#f44336',
      },
    },
  });




  useEffect(() => {
    // Fetch the services and set state
    const fetchServices = async () => {
      try {
        const response = await fetch('https://frek.cc/proxy/38.54.86.24:5005/update-routes');
        if (!response.ok) throw new Error('Failed to fetch services');
        const data = await response.json();
        setServicesData(data);
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    fetchServices();
  }, []);


  // Handle service selection
  const handleServiceChange = (event) => {
    const service = event.target.value;
    setSelectedService(service);

    if (servicesData[service]) {
      // Set senders and contents based on selected service
      setNewSenders(servicesData[service].allowed_senders.join(', '));
      setNewContents(servicesData[service].keywords.join(', '));
    } else {
      setNewSenders('');
      setNewContents('');
    }
  };





  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          statusResponseViber,
          statusResponseGrab,
          statusResponseFoodpanda,
          statusResponseGmail,
          statusResponseGigalink,
          statusResponseGcash,
          statusResponsePlayzone,
          statusResponseWhatsapp,
          statusResponseMoveit,
          statusResponseHotel101,
          allNumbersResponse,
          monitorResponse,
          senderContentResponse,
          noOtpNumbersViberResponse, // Add No OTP Numbers response viber
          noOtpNumbersGrabResponse, // Add No OTP Numbers response grab
          noOtpNumbersFoodpandaResponse, // Add No OTP Numbers response foodpanda
          noOtpNumbersGmailResponse, // Add No OTP Numbers response gmail
          noOtpNumbersGigalinkResponse, // Add No OTP Numbers response gigalink
          noOtpNumbersGcashResponse, // Add No OTP Numbers response Gcash
          noOtpNumbersPlayzoneResponse, // Add No OTP Numbers response playzone
          noOtpNumbersWhatsappResponse, // Add No OTP Numbers response whatsapp
          noOtpNumbersMoveitResponse, // Add No OTP Numbers response whatsapp
          noOtpNumbersHotel101Response, // Add No OTP Numbers response Hotel101
        ] = await Promise.all([
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/viber'), // viber
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/grab'), // grab
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/foodpanda'), // foodpanda
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/gmail'), // gmail
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/gigalink'), // Gigalink
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/gcash'), // Gcash
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/playzone'), // playzone
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/whatsapp'), // whatsapp
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/moveit'), // moveit
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/hotel101'), // hotel101
          fetch('https://frek.cc/proxy/38.54.86.24:5070/fetch-all-numbers'),
          fetch('https://frek.cc/proxy/38.54.86.24:6687/monitor-call/g9'),
          fetch('https://frek.cc/proxy/38.54.86.24:5070/get-sender-content'),
          fetch('https://frek.cc/proxy/38.54.86.24:7272/no_otp_numbers'), // Fetch No OTP Numbers viber
          fetch('https://frek.cc/proxy/38.54.86.24:7474/no_otp_numbers'), // Fetch No OTP Numbers grab
          fetch('https://frek.cc/proxy/38.54.86.24:9898/no_otp_numbers'), // Fetch No OTP Numbers foodpanda
          fetch('https://frek.cc/proxy/38.54.86.24:6565/no_otp_numbers'), // Fetch No OTP Numbers gmail
          fetch('https://frek.cc/proxy/38.54.86.24:8787/no_otp_numbers'), // Fetch No OTP Numbers Gigalink
          fetch('https://frek.cc/proxy/38.54.86.24:5353/no_otp_numbers'), // Fetch No OTP Numbers Gcash
          fetch('https://frek.cc/proxy/38.54.86.24:7171/no_otp_numbers'), // Fetch No OTP Numbers playzone
          fetch('https://frek.cc/proxy/38.54.86.24:5454/no_otp_numbers'), // Fetch No OTP Numbers whatsapp
          fetch('https://frek.cc/proxy/38.54.86.24:7676/no_otp_numbers'), // Fetch No OTP Numbers Moveit
          fetch('https://frek.cc/proxy/38.54.86.24:2929/no_otp_numbers'), // Fetch No OTP Numbers hotel101
        ]);

        if (
          !statusResponseViber.ok ||
          !statusResponseGrab.ok ||
          !statusResponseFoodpanda.ok ||
          !statusResponseGmail.ok ||
          !statusResponseGigalink.ok ||
          !statusResponseGcash.ok ||
          !statusResponsePlayzone.ok ||
          !statusResponseWhatsapp.ok ||
          !statusResponseMoveit.ok ||
          !statusResponseHotel101.ok ||
          !allNumbersResponse.ok ||
          !monitorResponse.ok ||
          !senderContentResponse.ok ||
          !noOtpNumbersViberResponse.ok ||// Check response for No OTP Numbers viber
          !noOtpNumbersGrabResponse.ok || // Check response for No OTP Numbers grab
          !noOtpNumbersFoodpandaResponse.ok || // Check response for No OTP Numbers foodpanda
          !noOtpNumbersGmailResponse.ok || // Check response for No OTP Numbers gmail
          !noOtpNumbersGigalinkResponse.ok ||  // Check response for No OTP Numbers gigalink
          !noOtpNumbersGcashResponse.ok || // Check response for No OTP Numbers Gcash
          !noOtpNumbersPlayzoneResponse.ok || // Check response for No OTP Numbers playzone
          !noOtpNumbersWhatsappResponse.ok || // Check response for No OTP Numbers whatsapp
          !noOtpNumbersMoveitResponse.ok ||  // Check response for No OTP Numbers Moveit
          !noOtpNumbersHotel101Response.ok  // Check response for No OTP Numbers hotel101
        ) {
          throw new Error('Failed to fetch one or more data sources.');
        }

        const [
          statusNumbersViberData,
          statusNumbersGrabData,
          statusNumbersFoodpandaData,
          statusNumbersGmailData,
          statusNumbersGigalinkData,
          statusNumbersGcashData,
          statusNumbersPlayzoneData,
          statusNumbersWhatsappData,
          statusNumbersMoveitData,
          statusNumbersHotel101Data,
          allNumbersData,
          monitorDataData,
          senderContentData,
          noOtpNumbersViberData,
          noOtpNumbersGrabData,
          noOtpNumbersFoodpandaData,
          noOtpNumbersGmailData,
          noOtpNumbersGigalinkData,
          noOtpNumbersGcashData,
          noOtpNumbersPlayzoneData,
          noOtpNumbersWhatsappData,
          noOtpNumbersMoveitData,
          noOtpNumbersHotel101Data,
        ] = await Promise.all([
          statusResponseViber.json(),
          statusResponseGrab.json(),
          statusResponseFoodpanda.json(),
          statusResponseGmail.json(),
          statusResponseGigalink.json(),
          statusResponseGcash.json(),
          statusResponsePlayzone.json(),
          statusResponseWhatsapp.json(),
          statusResponseMoveit.json(),
          statusResponseHotel101.json(),
          allNumbersResponse.json(),
          monitorResponse.json(),
          senderContentResponse.json(),
          noOtpNumbersViberResponse.json(), // Parse No OTP Numbers viber
          noOtpNumbersGrabResponse.json(), // Parse No OTP Numbers grab 
          noOtpNumbersFoodpandaResponse.json(), // Parse No OTP Numbers foodpanda
          noOtpNumbersGmailResponse.json(), // Parse No OTP Numbers gmail
          noOtpNumbersGigalinkResponse.json(), // Parse No OTP Numbers gigalink
          noOtpNumbersGcashResponse.json(), // Parse No OTP Numbers gcash
          noOtpNumbersPlayzoneResponse.json(), // Parse No OTP Numbers polayzone
          noOtpNumbersWhatsappResponse.json(), // Parse No OTP Numbers whatsapp
          noOtpNumbersMoveitResponse.json(), // Parse No OTP Numbers Moveit
          noOtpNumbersHotel101Response.json(), // Parse No OTP Numbers Hotel101
        ]);

        // Set state for No OTP Numbers
        setstatusNumbersViber(statusNumbersViberData);
        setstatusNumbersGrab(statusNumbersGrabData);
        setstatusNumbersFoodpanda(statusNumbersFoodpandaData);
        setstatusNumbersGmail(statusNumbersGmailData);
        setstatusNumbersGigalink(statusNumbersGigalinkData);
        setstatusNumbersGcash(statusNumbersGcashData);
        setstatusNumbersPlayzone(statusNumbersPlayzoneData);
        setstatusNumbersWhatsapp(statusNumbersWhatsappData);
        setstatusNumbersMoveit(statusNumbersMoveitData);
        setstatusNumbersHotel101(statusNumbersHotel101Data);
        setData(allNumbersData);
        setMonitorData(monitorDataData);
        setSenders(senderContentData.senders.join(', '));
        setContents(senderContentData.contents.join(', '));
        setNoOtpNumbersViber(noOtpNumbersViberData.no_otp_numbers); // Store No OTP Numbers viber
        setNoOtpNumbersGrab(noOtpNumbersGrabData.no_otp_numbers); // Store No OTP Numbers grab
        setNoOtpNumbersFoodpanda(noOtpNumbersFoodpandaData.no_otp_numbers); // Store No OTP Numbers foodpanda
        setNoOtpNumbersGmail(noOtpNumbersGmailData.no_otp_numbers); // Store No OTP Numbers gmail
        setNoOtpNumbersGigalink(noOtpNumbersGigalinkData.no_otp_numbers); // Store No OTP Numbers gigalink
        setNoOtpNumbersGcash(noOtpNumbersGcashData.no_otp_numbers); // Store No OTP Numbers Gcash
        setNoOtpNumbersPlayzone(noOtpNumbersPlayzoneData.no_otp_numbers); // Store No OTP Numbers playzone
        setNoOtpNumbersWhatsapp(noOtpNumbersWhatsappData.no_otp_numbers); // Store No OTP Numbers whatsapp
        setNoOtpNumbersMoveit(noOtpNumbersMoveitData.no_otp_numbers); // Store No OTP Numbers Moveit
        setNoOtpNumbersHotel101(noOtpNumbersHotel101Data.no_otp_numbers); // Store No OTP Numbers Hotel101
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 10000); // Fetch every 5 seconds
    return () => clearInterval(intervalId); // Cleanup interval
  }, []);


  useEffect(() => {
    document.title = 'G9 Ports Manager';
  }, []);

  const sendSwitchRequest = (basePort, portIndex) => {
    const binaryPayload = Array(16).fill('0');
    binaryPayload[portIndex - 1] = '1';
    const payloadValue = binaryPayload.join('');

    const payload = {
      [`goip_slot_selected(${basePort})`]: payloadValue,
    };

    fetch('https://frek.cc/proxy/38.54.86.24:6687/configure-ports/g9', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(payload),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Switch Response:', data);
        handleNotification(data.message);
      })
      .catch(error => {
        console.error('Error:', error);
        handleNotification('Failed to switch port.');
      });
  };

  const updateSenderContent = () => {
    const payload = {
      senders: newSenders,
      contents: newContents,
    };

    fetch('https://frek.cc/proxy/38.54.86.24:5070/update-sender-content', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Update Response:', data);
        handleNotification(data.status);
        setSenders(newSenders);
        setContents(newContents);
      })
      .catch(error => {
        console.error('Error:', error);
        handleNotification('Failed to update sender/content.');
      });
  };



  const resetPorts = () => {
    fetch('https://frek.cc/proxy/38.54.86.24:5070/reset-ports', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ action: 'reset' }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Reset Ports Response:', data);
        handleNotification(data.message);
      })
      .catch(error => {
        console.error('Error:', error);
        handleNotification('Failed to reset ports.');
      });
  };

  const changeIMEI = () => {
    fetch('https://frek.cc/proxy/38.54.86.24:6687/change-imei/g9', {
      method: 'GET',
    })
      .then(response => response.text())
      .then(text => {
        console.log('Change IMEI Response:', text);
        if (text.includes('IMEI Changing Success')) {
          handleNotification('IMEI successfully changed.');
        } else {
          handleNotification('Failed to change IMEI.');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        handleNotification('Failed to change IMEI.');
      });
  };

  const saveSettings = () => {
    fetch('https://frek.cc/proxy/38.54.86.24:6687/save/g9', {
      method: 'POST',
    })
      .then(response => response.text())
      .then(text => {
        console.log('Save Settings Response:', text);
        handleNotification(text.includes('success') ? 'Settings saved successfully.' : 'Failed to save settings.');
      })
      .catch(error => {
        console.error('Error:', error);
        handleNotification('Failed to save settings.');
      });
  };

  const rebootGateway = () => {
    fetch('https://frek.cc/proxy/38.54.86.24:6687/reboot/g9', {
      method: 'POST',
    })
      .then(response => response.text())
      .then(text => {
        console.log('Reboot Gateway Response:', text);
        handleNotification(text.includes('success') ? 'Gateway rebooted successfully.' : 'Failed to reboot gateway.');
      })
      .catch(error => {
        console.error('Error:', error);
        handleNotification('Failed to reboot gateway.');
      });
  };

  const confirmAction = (action) => {
    setActionToConfirm(() => action);
    setConfirmDialogOpen(true);
  };

  const handleConfirm = () => {
    if (actionToConfirm) actionToConfirm();
    setConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setConfirmDialogOpen(false);
    setActionToConfirm(null);
  };



  const handleNotification = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const createTable = (basePort) => {
    // Find the active entry as before
    const activeEntry = data.find(item => item[0].split('.')[0] === basePort) || [];
    const activePort = activeEntry[0] || `${basePort}.01`;
    const activeNumber = activeEntry[1] || '';
  
    // 32 labels in order (1 => "one", 2 => "two", ..., 32 => "thirtytwo")
    const labelMap = [
      "one","two","three","four","five","six","seven","eight",
      "nine","ten","eleven","twelve","thirteen","fourteen","fifteen","sixteen",
      "seventeen","eighteen","nineteen","twenty","twentyone","twentytwo","twentythree","twentyfour",
      "twentyfive","twentysix","twentyseven","twentyeight","twentynine","thirty","thirtyone","thirtytwo"
    ];
  
    // Convert basePort (1..32) to the right label
    let senderRange = "";
    if (basePort >= 1 && basePort <= 32) {
      senderRange = labelMap[basePort - 1]; 
    }
  
    // Then look up the sender(s) for that single port
    const activeSender = senderContent[senderRange]?.join(', ') || "No Sender";

    return (
      <ThemeProvider theme={darkTheme}>
        <div style={{ paddingTop: 0, paddingBottom: 10, paddingLeft: 3, paddingRight: 3 }}>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={1000}  // Auto-close after 4 seconds
            onClose={() => setSnackbarOpen(false)} // Close function
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}  // Position of the Snackbar
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity={snackbarSeverity}
              sx={{ width: '100%' }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>

          <TableContainer component={Paper} style={{ paddingTop: 0, paddingBottom: 3, paddingLeft: 3, paddingRight: 3 }}>
            <Typography variant="h6" gutterBottom>
              Active Port: {activePort}, Active Number: {activeNumber}, OTP: {activeSender}
            </Typography>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Port</TableCell>
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Num.</TableCell>
                 <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>WA</TableCell> 
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Vbr</TableCell>
                 {/* <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Grb</TableCell>*/}
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>FP</TableCell>
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Gml</TableCell>
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>GLnk</TableCell> 
                {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Gcsh</TableCell> */}
                {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Pz</TableCell> */}
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Mvit</TableCell>
                {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>H101</TableCell> */}
                  {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Port Stats</TableCell> */}
                  {/*<TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Signal</TableCell> */}
                  {/* <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>State</TableCell> */}
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Status</TableCell>
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Switch</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[...Array(16).keys()].map(i => {
                  const portNumber = `${basePort}.${String(i + 1).padStart(2, '0')}`;
                  const number = activeEntry[i + 2] || '';
                  const monitorEntry = monitorData.find(item => item.Port === portNumber) || {};

                  return (
                    <TableRow key={portNumber} sx={{
                      "&:last-child td, &:last-child th": {},
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(63, 81, 181, 0.1)',
                      },
                    }}>
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{portNumber}</TableCell>
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{number}</TableCell>
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersWhatsapp[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersWhatsapp.includes(number) ? 'Yes' : 'No'}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: 13.1,
                          fontWeight: 200,
                          color: noOtpNumbersViber[number] ? 'red' : 'inherit', // Check if the number exists in noOtpNumbers
                        }}
                        align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}
                      >{statusNumbersViber.includes(number) ? 'Yes' : 'No'}</TableCell>
                   {/*   <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersGrab[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersGrab.includes(number) ? 'Yes' : 'No'}
                      </TableCell> */}

                      <TableCell
                        sx={{
                          fontSize: 13.1,
                          fontWeight: 200,
                          color: noOtpNumbersFoodpanda[number] ? 'red' : 'inherit',
                        }}
                        align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}
                      >{statusNumbersFoodpanda.includes(number) ? 'Yes' : 'No'}</TableCell>
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersGmail[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersGmail.includes(number) ? 'Yes' : 'No'}
                      </TableCell>
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersGigalink[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersGigalink.includes(number) ? 'Yes' : 'No'}
                      </TableCell> 

                  {/*    <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersGcash[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersGcash.includes(number) ? 'Yes' : 'No'}
                      </TableCell> */}

                  {/*    <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersPlayzone[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersPlayzone.includes(number) ? 'Yes' : 'No'}
                      </TableCell> */}
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersMoveit[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersMoveit.includes(number) ? 'Yes' : 'No'}
                      </TableCell>
                    {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200, color: noOtpNumbersHotel101[number] ? 'red' : 'inherit', }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        {statusNumbersHotel101.includes(number) ? 'Yes' : 'No'}
                      </TableCell>*/}


                      {/*   <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{monitorEntry['Port Stats'] || ''}</TableCell>  */}
                      {/*   <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{monitorEntry.Signal || ''}</TableCell> */}
                      {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{monitorEntry.State || ''}</TableCell> */}
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{monitorEntry.Status || ''}</TableCell>
                      <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>
                        <button
                          style={{
                            backgroundColor: '#424242',
                            color: '#fff',
                            border: 'none',
                            padding: '4px 8px',
                            cursor: 'pointer',
                          }}
                          onClick={() => sendSwitchRequest(basePort, i + 1)}
                        >
                          Switch
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

        </div>
      </ThemeProvider>
    );
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      <div>
        {/* Title */}
        <Typography variant="h4" gutterBottom align="center">
          G9 Ports Manager for TG
        </Typography>

        {/* Controls */}
        <Box mb={4}>
          <Typography variant="h6">Current Senders and Contents</Typography>

          <Typography>Senders: {senders}</Typography>
          <Typography>Contents: {contents}</Typography>

          <FormControl fullWidth margin="normal">
            <InputLabel>Select a Service</InputLabel>
            <Select value={selectedService} onChange={handleServiceChange}>
              {Object.keys(servicesData).map((service) => (
                <MenuItem key={service} value={service}>
                  {service.toUpperCase()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="New Senders"
            value={newSenders}
            onChange={(e) => setNewSenders(e.target.value)}
            fullWidth
            margin="normal"
          />

          <TextField
            label="New Contents"
            value={newContents}
            onChange={(e) => setNewContents(e.target.value)}
            fullWidth
            margin="normal"
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() => confirmAction(updateSenderContent)}
          >
            Update Senders and Contents
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => confirmAction(resetPorts)}
            sx={{ ml: 2 }}
          >
            Reset All Ports
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => confirmAction(changeIMEI)}
            sx={{ ml: 2 }}
          >
            Change IMEI
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => confirmAction(saveSettings)}
            sx={{ ml: 2 }}
          >
            Save
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => confirmAction(rebootGateway)}
            sx={{ ml: 2 }}
          >
            Reboot
          </Button>
        </Box>

        {/* Tables */}
        <Box id="tablesContainer">
          {[...Array(32).keys()].map((i) => createTable(String(i + 1)))}
        </Box>

        {/* Dialog */}
        <Dialog
          open={confirmDialogOpen}
          onClose={handleCancel}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <DialogTitle id="confirm-dialog-title">Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-dialog-description">
              Are you sure you want to proceed with this action?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="secondary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default G9PortsBingo;
